import { useCallback } from 'react'

import { useInvoiceDueDateTerms } from 'Invoices/hooks/useInvoiceDueDateTerms'
import {
  formatInvoiceDueDate,
  type FormatInvoiceDueDateOptions
} from 'Invoices/utils'

export const useInvoiceDueDateFormatter = () => {
  const { calculatedFrom } = useInvoiceDueDateTerms()

  return useCallback(
    (options: FormatInvoiceDueDateOptions) =>
      formatInvoiceDueDate({ ...options, calculatedFrom }),
    [calculatedFrom]
  )
}
